let mapboxConfiguration;

export default class SourceNLayerManager {
  constructor({ main, opts }) {
    this._ = main;

    mapboxConfiguration = opts.mapboxConfiguration;
    this.setLayer = opts.setLayer;

    this._.settings.set({ colorScales: opts.modules.colorScales });
    this._.settings.set({ legendTitle: opts.legendTitle });
  }

  loadSources() {
    mapboxConfiguration.sources.forEach((item, i) => {
      const sourceConfig = {
        type: item.type,
        url: item.url,
      };

      if (item.hasOwnProperty("promoteId")) {
        sourceConfig.promoteId = item.promoteId;
      }
      this._.map.mapboxmap.addSource(item.key, sourceConfig);
    }, this);

    this._.map.mapboxmap.on("sourcedata", this.shouldAddLayers.bind(this));
  }

  shouldAddLayers(e) {
    const sources = mapboxConfiguration.sources.map((d) => d.key);

    const allSourcesLoaded = sources
      .map((source) => {
        return (
          this._.map.mapboxmap.getSource(source) &&
          this._.map.mapboxmap.isSourceLoaded(source)
        );
      })
      .every((x) => x === true);

    if (allSourcesLoaded && !this.layersAdded) {
      this.layersAdded = true;
      this.addLayers();
    }
  }

  addLayers() {
    mapboxConfiguration.layers.forEach((item, i) => {
      this._.map.mapboxmap.addLayer(item.layer, item.beforeId);
    }, this);

    const activeFilter = this._.settings.get("activeFilter");

    this.setLayer.call(this, activeFilter);

    if (this._.settings.get("createLegend")) {
      this._.legend.updateLegend(activeFilter);
    }
  }

  // setLayer(variable) {...}

  colorScale({ party, color, value }, escrutado, scale) {
    if (escrutado !== undefined && escrutado === 0)
      return "rgba(220, 220, 220, 0.5)";
    const valueOpacity = scale(value);
    const outputColor = hexToRgbA(color, valueOpacity);

    return outputColor;

    function hexToRgbA(hex = "f2f2f2", opacity) {
      // remove invalid characters
      hex = hex.replace(/[^0-9a-fA-F]/g, "");

      if (hex.length < 5) {
        // 3, 4 characters double-up
        hex = hex
          .split("")
          .map((s) => s + s)
          .join("");
      }

      // parse pairs of two
      let rgb = hex.match(/.{1,2}/g).map((s) => parseInt(s, 16));

      if (opacity !== undefined) {
        return `rgba(${rgb.join(",")},${opacity.toFixed(2)})`;
      }

      return "rgb(" + rgb.join(",") + ")";
    }
  }
}
